// Default vendor used when a property's VendorId has no matching entry
// in vendors.json. This ensures new components are still displayed.
const DEFAULT_VENDOR = {
    name: '51Degrees',
    iconUrl: '/images/icon-feature-vendor-51d.png',
    imageUrl: '/images/logo.png',
    map: '',
    enabled: true,
    addon: null
};

export function findVendor(vendors, vendorId) {
    return vendors.find(v => v.map === vendorId) || { ...DEFAULT_VENDOR, map: vendorId };
}
